/* ============================================================
   MIQAZ · kleine Verhaltens-Ebene (ohne Abhängigkeiten)
   1. Einblenden beim Scrollen: Elemente mit [data-mq-zeigen]
   2. Header-Zustand: body.mq-gescrollt nach 8px Scroll
   3. Laufband (mq-ticker): Pause-Knopf für Tastatur/Screenreader
   4. FAQ: nur ein <details> pro Liste offen (optional per data-mq-einzeln)
   Respektiert „Bewegung reduzieren“ des Systems.
   ============================================================ */
(function () {
  'use strict';
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1 · Einblenden */
  function zeigen(root) {
    var els = (root || document).querySelectorAll('[data-mq-zeigen]:not(.mq-sichtbar)');
    if (!els.length) return;
    if (ruhig || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('mq-sichtbar'); });
      return;
    }
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mq-sichtbar'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2 · Header-Zustand */
  var tick = false;
  function scrollZustand() {
    document.body.classList.toggle('mq-gescrollt', window.scrollY > 8);
    tick = false;
  }

  /* 3 · Laufband-Pause */
  function ticker(root) {
    (root || document).querySelectorAll('[data-mq-ticker]').forEach(function (t) {
      var knopf = t.querySelector('[data-mq-ticker-pause]');
      if (!knopf || knopf.dataset.mqBereit) return;
      knopf.dataset.mqBereit = '1';
      knopf.addEventListener('click', function () {
        var pausiert = t.classList.toggle('mq-ticker--pause');
        knopf.setAttribute('aria-pressed', pausiert ? 'true' : 'false');
        knopf.setAttribute('aria-label', pausiert ? knopf.dataset.labelStart : knopf.dataset.labelPause);
      });
    });
  }

  /* 4 · FAQ: Einzeln öffnen */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    var liste = d.closest('[data-mq-einzeln]');
    if (!liste) return;
    liste.querySelectorAll('details[open]').forEach(function (x) { if (x !== d) x.open = false; });
  }, true);

  function start(root) { zeigen(root); ticker(root); }

  document.addEventListener('DOMContentLoaded', function () {
    start(document);
    scrollZustand();
  });
  window.addEventListener('scroll', function () {
    if (!tick) { tick = true; window.requestAnimationFrame(scrollZustand); }
  }, { passive: true });

  /* Theme-Editor: neu geladene Abschnitte sofort zeigen */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
